module.exports = __webpack_public_path__ + "static/media/undraw_love_xfcv.cf036b9e.svg";